module.exports = __webpack_public_path__ + "img/world.7e31e1dd.webp";